import { download, generateCsv, mkConfig } from "export-to-csv"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { toCurrency, toDinero } from "../../../../currency/currencyLib"
import { useDateTime } from "../../../../localization/useDateTime"
import { FeeItem } from "../supplierAcquiringReportsTypes"
import { useMoney } from "../../../../currency/useMoney"

export function useExportAcquiringReportsFeesToCsv(startDate: string, endDate: string) {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()
    const moneyFactory = useMoney({ locale: "da-DK" })
    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(startDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(endDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-reconciliation-acquiring-fees-${formattedStartDate}_${formattedEndDate}`,
    })

    const handleExportRows = (fees?: FeeItem[]) => {
        if (!fees) return

        const exportRows = fees.map((fee) => {
            return {
                "From date": formattedStartDate,
                "To date": formattedEndDate,
                "Order ID": fee.pspPaymentMerchantReference ?? "",
                "PSP Reference": fee.pspPaymentPspReference ?? "",
                "Booked time": dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(fee.bookingDate)),
                "Available date": dateTimeFactory.formatDate(dateTimeFactory.fromApi(fee.valueDate)),
                Type: l10n.getStringForEnum("supplier-acquiring-fees-table-type-mode", fee.type ?? "", ""),
                ["Amount" + ` (${moneyFactory.getLocalizedCurrencySymbol(toCurrency(fee.amount.currency))})`]:
                    moneyFactory.formatAsNumber(toDinero(fee.amount)),
                Merchant: fee?.merchant
                    ? `${fee.merchant.caseNumber ? `${fee.merchant.caseNumber}, ` : ""} ${fee.merchant.name}`
                    : "-",
                "Adyen account": fee.balanceAccount,
            }
        })

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
